import styled from "styled-components";

export const ContentContainer = styled.div`
  background: ${({ theme }) => theme.card.white.background};
`;

export const ActionsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 12px;
`;

export const HintText = styled.div`
  margin-top: 12px;
`;

export const InfoHintIcon = styled.span`
  color: ${({ theme }) => theme.text.color.subtitle};
  cursor: help;
  display: inline-flex;
  align-items: center;
`;

export const NoticeText = styled.div`
  margin-top: 8px;
`;

export const ErrorWrapper = styled.div`
  margin-top: 8px;
`;

export const RetryWrapper = styled.div`
  margin-top: 8px;
`;
